module.exports = __webpack_public_path__ + "static/media/cert8.1544f7f8.png";